import React from 'react'
import ShopByCategory from '../category/ShopByCategory';


const Home = () => {
     const [cart, setCart] = React.useState([]);

  const addToCart = (item) => setCart((c) => [...c, item]);

  // Ensure product.category matches one of the category IDs above
  const products = [
    
    { id: 1, name: "Nestle", category: "Chocolate", image: require("../images/nestle.jpg"), description: "..." },
    // { id: 2, name: "Saffola",  category: "oil", image: require("../images/saffola.jpg"),  description: "..." },
    { id: 3, name: "Sunfeast",  category: "Biscuts", image: require("../images/sunfeast.jpg"),  description: "..." },
    { id: 4, name: "Fig",  category: "Dryfruits", image: require("../images/fig.jpg"),  description: "..." },
    { id: 5, name: "Apple",  category: "Fruits", image: require("../images/apple.jpg"), description: "..." },
    { id: 6, name: "Pepsi",  category: "Beverages", image: require("../images/pepsi.jpg"), description: "..." },
    { id: 7, name: "Little Hearts",  category: "Snacks", image: require("../images/littlehearts.webp"), description: "..." },
      { id: 21, name: "Chips",  category: "Snacks", image: require("../images/chips.webp"), description: "..." },
    { id: 9, name: "Milk",  category: "dairy", image: require("../images/milk.jpg"), description: "..." },
    { id: 10, name: "Tomato",  category: "vegitables", image: require("../images/tomato.png"), description: "..." },
    { id: 11, name: "Brown Rice",  category: "Rice", image: require("../images/brownrice.jpg"), description: "..." },
  
   { id: 13, name: "Cumin",  category: "herbs&spices", image: require("../images/cumin.webp"), description: "..." },
    { id: 14, name: "Perfume",  category: "personalcare", image: require("../images/prefumes.jpg"), description: "..." },
    
    { id: 15, name: "Cadbury",  category: "Chocolate", image: require("../images/cadbury.jpg"),  description: "..." },
    // { id: 16, name: "Fortune",  category: "oil", image: require("../images/fortune.jpg"),  description: "..." },
    { id: 17, name: "Britannia",  category: "Biscuts", image: require("../images/briatnnia.webp"),  description: "..." },
    { id: 18, name: "Pistachio",  category: "Dryfruits", image: require("../images/pista.webp"),  description: "..." },
    { id: 19, name: "Banana",  category: "Fruits", image: require("../images/banana.webp"), description: "..." },
    { id: 20, name: "Coca-Cola",  category: "Beverages", image: require("../images/cocacola.jpg"), description: "..." },
 
     { id: 8, name: "Detergents",  category: "homecare", image: require("../images/detergents.jpg"), description: "..." },
    { id: 22, name: "Dish Wash",  category: "homecare", image: require("../images/dishwash.jpg"), description: "..." },
    { id: 23, name: "Butter",  category: "dairy", image: require("../images/butter.jpg"), description: "..." },
     { id: 24, name: "Carrot",  category: "vegitables", image: require("../images/carrot.jpg"), description: "..." },
      { id: 34, name: "Cauliflower",  category: "vegitables", image: require("../images/califlower.jpg"), description: "..." },
    { id: 25, name: "Basmati Rice",  category: "Rice", image: require("../images/basmati.jpg"), description: "..." },
     { id: 12, name: "Baby Soap",  category: "baby", image: require("../images/babysoap.webp"), description: "..." },
   { id: 26, name: "Baby Diaper",  category: "baby", image: require("../images/babydiaper.jpg"), description: "..." },
   
    { id: 28, name: "Sunscreen",  category: "personalcare", image: require("../images/sunscreen.avif"), description: "..." },


   { id: 29, name: "Fanta",  category: "Beverages", image: require("../images/fanta.jpg"), description: "..." },
    { id: 30, name: "Raisin",  category: "Dryfruits", image: require("../images/raisin.jpg"),  description: "..." },
    { id: 27, name: "Clove",  category: "herbs&spices", image: require("../images/clove.jpg"), description: "..." },
    { id: 31, name: "Hershey",  category: "Chocolate", image: require("../images/hershey.jpg"),  description: "..." },
    // { id: 32, name: "Dabur",  category: "oil", image: require("../images/dabur.avif"),  description: "..." },
    { id: 33, name: "Oreo",  category: "Biscuts", image: require("../images/oreo.webp"),  description: "..." },
    
   
  ];
  return (
    <div>
      <ShopByCategory products={products} addToCart={addToCart} />

    </div>
  )
}

export default Home
